import type { JSX } from 'react';

/**
 * Сообщение об исходе действия. `role="alert"` для ошибки (нужно объявить сразу)
 * и `role="status"` для успеха (объявляется вежливо, не перебивая).
 */
export function FormMessage({
  kind,
  children,
}: {
  kind: 'error' | 'success';
  children: string;
}): JSX.Element {
  const isError = kind === 'error';
  return (
    <p
      role={isError ? 'alert' : 'status'}
      className={`rounded-[var(--kitup-radius-sm)] px-3 py-2 text-sm ${
        isError ? 'bg-red-50 text-red-700' : 'bg-emerald-50 text-emerald-800'
      }`}
    >
      {children}
    </p>
  );
}
